import { IOrder } from '@@functions/models';

export class Item implements IOrder {
  id!: string;
  orderDate!: string;
  status!: number;
  conditionChecked!: boolean;

  transportUseYardsForTransportTo!: boolean;
  transportFromId!: string;
  transportFromName!: string;
  transportToId!: string;
  transportToName!: string;
  transportToAddress!: string;
  transportToArea!: string;
  transportToRemarks!: string;
  transportToPhone!: string;
  transportToIncharge!: string;
  transportVendorId!: string;
  transportVendorName!: string;
  transportOptionNumberPlateCut!: boolean;
  transportCostId!: string;
  transportActualCost!: number | string;
  transportTotalActualCost!: number;
  transportCost!: number | string;
  regularCharge!: string;
  yardConfirmationDate!: string;
  yardConfirmed!: string;
  landTransportationArrangementDate!: string;
  landTransportationArranger!: string;
  transportTotalCost!: number;
  transportOutFee!: number;
  transportNumberPlateCutFee!: number;
  transportRemarks!: string;
  transportRequestDate!: string;
  transportRequestConfirmDate!: string;
  transportEstimatedArrivalDate!: string;

  exportCountry!: string;
  exportDischargePort!: string;
  exportType!: string;
  exportHasBodyWorkRequest!: boolean;
  exportHasInspectionRequest!: boolean;

  vinNo!: string;
  model!: string;
  grade!: string;
  year!: number;
  mileage!: number;
  score!: string;
  color!: string;
  hasNumberPlate!: boolean;
  imageUrls!: string[];
  auctionSheetUrl!: string;
  lotNo!: string;

  conditionIsLowDown!: boolean;
  conditionIsFlatBody!: boolean;
  conditionIsImmovable!: boolean;
  conditionISAccident!: boolean;
  conditionIsPoorElec!: boolean;
  conditionIsDRVSidePWFail!: boolean;
  conditionIsASISMovable!: boolean;
  conditionIsASISImmovable!: boolean;
  conditionIsWithBox!: boolean;
  conditionIsOilLeak!: boolean;
  conditionEngFail!: boolean;
  conditionEngFailLv!: string;
  conditionRust!: boolean;
  conditionRustLv!: string;
  conditionRemarks!: string;
  regExpiryDate!: string;
  transportNote!: string;
  customerName!: string;
  customerId!: string;
  customerTel!: string;
  customerPSTNM!: string;
  customerAddress!: string;
  customerGrade!: string;
  pos!: string;
  postAccount!: string;
  matterNo!: string;
  maker!: string;
  yardTransportId!: string;
  yardTransportName!: string;
  yardAdressTransport!: string;
  yardAreaTransport!: string;
  transportRequestChange!: string;
  newRequestTransportFlg!: string;
  controlListTransportFlg!: boolean;
  hasNumberPlateChange!: boolean;
  requestDeleteAuctionFlg!: boolean;
  confirmFaxReply!: boolean;
  confirmOfDelivery!: boolean;
  handlingCompany!: string;
  yardArea!: string;
  yardName!: string;
  checktransportRevert!: boolean;
  tranRequest!: number;
  // checkRevert !: boolean;
  priceSize18!:boolean;
  priceSize23!:boolean;
  suppliersName!:string;
  addressByZipcode!:string;
  areaByZipcode!:string;
  placeId!:number;
  satelliteId!:number;
  yardId!:string;
  handlingCompanyEn!:string;
  handlingCompanyJp!:string;
  yardCategory!:string;
  isUpdate!:number;
  yardIdTemp!:string;
  fromYardPlace!:number;
  isOpenSearchAddressByZipCodePopupFlag!: boolean;
  invoiceIsuueDate!: string;
  yardCity1!: string;
  dateConfirmFeeTransport!:string;
  userConfirmFeeTransport!:string;
  transportDetailId!: number;
  conditionIsSelftpropelled!: boolean;
  conditionIsLoadedTransport!: boolean;
  checkDupplicateVinNo!:boolean;
  numberPlatePickUp!: boolean;
  numberDeliveryAddress!: string;
  requestVehicleNumberCut!:boolean;
  updateTime: number;
  isInvoiceFinish: '0' | '1';
  isDailyUpdateChecked: '0' | '1';
  invoicePid!: string;
  constructor(o: IOrder) {
    this.id = o.id;
    this.status = o.status || 0;
    this.conditionChecked = o.conditionChecked || false;
    this.hasNumberPlate = o.hasNumberPlate || false;
    this.transportUseYardsForTransportTo =
      o.transportUseYardsForTransportTo || true;
    this.transportFromId = o.transportFromId || '';
    this.transportFromName = o.transportFromName || '';
    this.transportToId = o.transportToId || '';
    this.transportToName = o.transportToName || '';
    this.transportToAddress = o.transportToAddress || '';
    this.transportToRemarks = o.transportToRemarks || '';
    this.transportToPhone = o.transportToPhone || '';
    this.transportToIncharge = o.transportToIncharge || '';
    this.transportOptionNumberPlateCut =
      o.transportOptionNumberPlateCut || false;
    this.transportToArea = o.transportToArea || '';
    this.transportVendorId = o.transportVendorId || '';
    this.transportVendorName = o.transportVendorName || '';
    this.transportCostId = o.transportCostId || '';
    this.transportActualCost = o.transportActualCost===0 ? 0 : o.transportActualCost || '' ;
    this.transportTotalActualCost = o.transportTotalActualCost || 0;
    this.transportCost = o.transportCost===0 ? 0 :o.transportCost  || '';
    this.regularCharge = o.regularCharge || '';
    this.yardConfirmationDate = o.yardConfirmationDate || '';
    this.yardConfirmed = o.yardConfirmed || '';
    this.landTransportationArrangementDate =
      o.landTransportationArrangementDate || '';
    this.landTransportationArranger = o.landTransportationArranger || '';
    this.transportTotalCost = o.transportTotalCost || 0;
    this.transportOutFee = o.transportOutFee || 0;
    this.transportNumberPlateCutFee = o.transportNumberPlateCutFee || 0;
    this.transportRemarks = o.transportRemarks || '';
    this.transportRequestDate = o.transportRequestDate || '';
    this.transportRequestConfirmDate = o.transportRequestConfirmDate || '';
    this.transportEstimatedArrivalDate = o.transportEstimatedArrivalDate || '';

    this.orderDate = o.orderDate || '';
    this.vinNo = o.vinNo || '';
    this.auctionSheetUrl = o.auctionSheetUrl || '';
    this.imageUrls = o.imageUrls || [];
    this.lotNo = o.lotNo || '';

    this.model = o.model || '';
    this.grade = o.grade || '';
    this.year = o.year || 0;
    this.mileage = o.mileage || 0;
    this.color = o.color || '';
    this.score = o.score || '';

    this.exportCountry = o.exportCountry || '';
    this.exportDischargePort = o.exportDischargePort || '';
    this.exportType = o.exportType || '';
    this.exportHasBodyWorkRequest = o.exportHasBodyWorkRequest || false;
    this.exportHasInspectionRequest = o.exportHasInspectionRequest || false;

    this.conditionIsLowDown = o.conditionIsLowDown || false;
    this.conditionIsFlatBody = o.conditionIsFlatBody || false;
    this.conditionIsImmovable = o.conditionIsImmovable || false;
    this.conditionISAccident = o.conditionISAccident || false;
    this.conditionIsPoorElec = o.conditionIsPoorElec || false;
    this.conditionIsDRVSidePWFail = o.conditionIsDRVSidePWFail || false;
    this.conditionIsASISMovable = o.conditionIsASISMovable || false;
    this.conditionIsASISImmovable = o.conditionIsASISImmovable || false;
    this.conditionIsWithBox = o.conditionIsWithBox || false;
    this.conditionIsOilLeak = o.conditionIsOilLeak || false;
    this.conditionEngFail = o.conditionEngFail || false;
    this.conditionEngFailLv = o.conditionEngFailLv || '';
    this.conditionRust = o.conditionRust || false;
    this.conditionRustLv = o.conditionRustLv || '';
    this.conditionRemarks = o.conditionRemarks || '';
    this.regExpiryDate = o.regExpiryDate || '';
    this.transportNote = o.transportNote || '';
    this.customerName = o.customerName || '';
    this.customerId = o.customerId || '';
    this.customerTel = o.customerTel || '';
    this.customerPSTNM = o.customerPSTNM || '';
    this.customerAddress = o.customerAddress || '';
    this.customerGrade = o.customerGrade || '';
    this.pos = o.pos || '';
    this.postAccount = o.postAccount || '';
    this.matterNo = o.matterNo || '';
    this.maker = o.maker || '';
    this.yardTransportId = o.yardTransportId || '';
    this.yardTransportName = o.yardTransportName || '';
    this.yardAdressTransport = o.yardAdressTransport || '';
    this.yardAreaTransport = o.yardAreaTransport || '';
    this.transportRequestChange = o.transportRequestChange || '';
    this.controlListTransportFlg = o.controlListTransportFlg || false;
    this.newRequestTransportFlg = o.newRequestTransportFlg || 'false';
    this.hasNumberPlateChange = o.hasNumberPlateChange || false;
    this.requestDeleteAuctionFlg = o.requestDeleteAuctionFlg || false;
    this.confirmFaxReply = o.confirmFaxReply || false;
    this.confirmOfDelivery = o.confirmOfDelivery || false;
    this.handlingCompany = o.handlingCompany || '';
    this.yardArea = o.yardArea || '';
    this.yardName = o.yardName || '';
    this.checktransportRevert = o.checktransportRevert || false;
    // this.checkRevert = o.checkRevert || false;
    this.tranRequest = o.tranRequest || 1;
    this.priceSize18 = o.priceSize18 || false;
    this.priceSize23 = o.priceSize23 || false;
    this.suppliersName = o.suppliersName || '';
    this.addressByZipcode = o.addressByZipcode || '';
    this.areaByZipcode = o.areaByZipcode || '';
    this.placeId = o.placeId || -1;
    this.satelliteId= o.satelliteId || -1;
    this.yardId = o.yardId || '-1';
    this.handlingCompanyEn = o.handlingCompanyEn || '';
    this.handlingCompanyJp = o.handlingCompanyJp || '';
    this.yardCategory = o.yardCategory || '0';
    this.isUpdate = o.isUpdate || 0;
    this.yardIdTemp = o.yardIdTemp || '-1';
    this.fromYardPlace = o.fromYardPlace || -1;
    this.isOpenSearchAddressByZipCodePopupFlag = o.isOpenSearchAddressByZipCodePopupFlag || false;
    this.invoiceIsuueDate = o.invoiceIsuueDate || '';
    this.yardCity1 = o.yardCity1 || '';
    this.dateConfirmFeeTransport = o.dateConfirmFeeTransport || '';
    this.userConfirmFeeTransport = o.userConfirmFeeTransport || '';
    this.transportDetailId = o.transportDetailId || 0;
    this.conditionIsSelftpropelled = o.conditionIsSelftpropelled || false;
    this.conditionIsLoadedTransport = o.conditionIsLoadedTransport || false;
    this.checkDupplicateVinNo = o.checkDupplicateVinNo || false;
    this.numberPlatePickUp = o.numberPlatePickUp || false;
    this.numberDeliveryAddress =o.numberDeliveryAddress || '';
    this.requestVehicleNumberCut = o.requestVehicleNumberCut || false;
    this.updateTime = o.updateTime !== undefined && o.updateTime > 0  ? o.updateTime : 0;
    this.isInvoiceFinish = o.isInvoiceFinish || '0';
    this.isDailyUpdateChecked = o.isDailyUpdateChecked || '0';
    this.invoicePid = o.invoicePid || '';
  }
  deepUnescape(str:any) {
    let s = String(str).trim();

    const stripOuterQuotes = (input:any) => {
      if ((input.startsWith('"') && input.endsWith('"')) || 
          (input.startsWith("'") && input.endsWith("'"))) {
        return input.slice(1, -1);
      }
      return input;
    };

    for (let i = 0; i < 10; i++) {
      const before = s;
      s = stripOuterQuotes(s);

      s = s.replace(/\\\//g, '/')
          .replace(/\\"/g, '"')
          .replace(/\\\\/g, '\\');

      if (s === before) break;
    }

    return s;
  }
  images() {
    return [...this.imageUrls, this.auctionSheetUrl].filter(
      (url) => url
    ).map(x=> this.deepUnescape(x))
    .map(y => y.replace(/"+$/g, '').replace(/^"+/g, ''))
    .filter(y => y.trim() !== 'null' && y.trim().length > 0);
  }
  getRemarks() {
    return [
      this.conditionIsLowDown ? 'ローダウン' : '',
      this.conditionIsFlatBody ? '平ボディ' : '',
      this.conditionIsImmovable ? '不動車' : '',
      this.conditionISAccident ? '事故車' : '',
      this.conditionIsPoorElec ? '電格不良' : '',
      this.conditionIsDRVSidePWFail ? '運転席PW不良' : '',
      this.conditionIsASISMovable ? '現状車(可動)' : '',
      this.conditionIsASISImmovable ? '現状車(不動)' : '',
      this.conditionIsWithBox ? '箱付き' : '',
      this.conditionIsOilLeak ? 'オイル漏れ' : '',
      this.conditionEngFail ? 'エンジン不調 ' + this.conditionEngFailLv : '',
      this.conditionRust ? 'サビ' + this.conditionRustLv : '',
      this.conditionRemarks,
      this.conditionIsSelftpropelled ? '自走陸送でも問題有りません。' : '',
      this.conditionIsLoadedTransport ? '自走陸送は行わないようにお願いします。' : '',
    ]
      .map((s) => s.trim())
      .filter((s) => s.length > 0)
      .join('/');
  }
  getData() {
    return (Object.keys(this) as Array<keyof Item>).reduce((o, k) => {
      o[k] = this[k];
      return o;
    }, {} as any);
  }
}
